export default __webpack_public_path__ + "static/logo-14-8db6595beae1f51c065d961bab2efa47.jpeg";